/*=============================================== CodeContainerPage ===============================================*/

import { CodeContainer } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, iconBoxicon } from "data"

const CodeContainerPage = () => {
    const items: ItemType[] = [
        {
            content: (
                <CodeContainer language="javascript">
                    {
                        'const unslugify = str => {\n    return capitalize(str.replaceAll("-", " "))\n}'
                    }
                </CodeContainer>
            ),
            code: '<CodeContainer language="javascript">\n    {\'const unslugify = str => {\\n    return capitalize(str.replaceAll("-", " "))\\n}\'}\n</CodeContainer>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "language",
            type: "string",
            possibleString: (
                <>
                    see the full list of languages{" "}
                    <a
                        href="https://github.com/react-syntax-highlighter/react-syntax-highlighter/blob/HEAD/AVAILABLE_LANGUAGES_HLJS.MD"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        here
                    </a>
                    .
                </>
            ),
            default: "javascript",
        },
        {
            subtitle: "style",
            type: "object",
            possibleString: (
                <>
                    see the full list of styles{" "}
                    <a
                        href="https://github.com/react-syntax-highlighter/react-syntax-highlighter/blob/HEAD/AVAILABLE_STYLES_HLJS.MD"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        here
                    </a>
                    .
                </>
            ),
            default: "atomOneDark",
        },
        {
            subtitle: "color",
            intro: (
                <>
                    This disables <code>syntax highlighter</code>.
                </>
            ),
            type: "string",
            possibleString: commonProps.allColors,
        },
        "separator",
        {
            subtitle: "copyButton",
            type: "boolean or object",
            default: "true",
        },
        {
            title: (
                <>
                    <code>copyButton</code> object
                </>
            ),
            subtitle: "iconCopy",
            intro: commonProps.addIconCapital,
            type: "string",
            default: iconBoxicon("clipboard"),
        },
        {
            subtitle: "iconCopied",
            type: "string",
            default: iconBoxicon("check"),
        },
        {
            subtitle: "iconSizeCopy",
            type: "number",
            default: "32 * 0.7",
        },
        {
            subtitle: "iconSizeCopied",
            type: "number",
            default: "32 * 0.7",
        },
        {
            subtitle: "labelCopy",
            type: "string",
            default: "Copy",
        },
        {
            subtitle: "labelCopied",
            type: "string",
            default: "Copied!",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default CodeContainerPage
